var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-collapsable", {
    attrs: {
      headerClass: _vm.headerClass,
      dialogClass: "bustachiusa",
      dialogProp: _vm.dialog,
    },
    on: { changeCollapse: _vm.changeCollapse },
    scopedSlots: _vm._u([
      {
        key: "visible",
        fn: function () {
          return [
            _vm.asta_settings.timeout_s &&
            _vm.calciatoreInAsta &&
            !_vm.offerto &&
            _vm.active
              ? _c("progress-countdown", {
                  ref: "timer_bustachiusa",
                  attrs: {
                    time: _vm.asta_settings.timeout_s,
                    name: "bustachiusa",
                  },
                  on: { timeover: _vm.timeoverBustaChiusa },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.collapsed && _vm.passato
              ? _c("v-icon", [_vm._v("airline_stops")])
              : _vm.collapsed && _vm.offerto
              ? _c("squadra-offerta", {
                  attrs: {
                    offerta: _vm.miaOfferta,
                    label: "",
                    uid: _vm.user_uid,
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "title",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.offerteCompletate
                    ? "Tutti hanno inviato la busta"
                    : !_vm.active && _vm.admin
                    ? "Attendi tutte le offerte"
                    : "Fai offerta"
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.calciatoreInAsta
              ? _c("calciatore-battuto", {
                  attrs: { id: _vm.calciatoreInAsta, xLarge: "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.roundStep &&
            _vm.roundStep.type == _vm.Constants.ROUND_STEP.BUSTE
              ? _c(
                  "div",
                  [
                    _c(
                      "v-list",
                      { staticClass: "lista_buste" },
                      _vm._l(_vm.offerte, function (off) {
                        return _c(
                          "v-list-item",
                          { key: off.s },
                          [
                            _c("v-list-item-avatar", [
                              _c("img", {
                                attrs: { src: _vm.squadra(off.s).pic },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.squadra(off.s).name
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                off.o > _vm.Constants.OFFERTA.PASSO
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "text",
                                              "x-small": "",
                                            },
                                          },
                                          [_vm._v("schedule")]
                                        ),
                                        _vm._v(" "),
                                        _c("small", [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.offertaTime(off.s)
                                              ),
                                            },
                                          }),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _c("small", [_vm._v("Nessuna offerta")]),
                                    ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item-action",
                              [
                                off.o == _vm.migliore_offerta.offerta &&
                                off.o !== _vm.Constants.OFFERTA.PASSO
                                  ? _c(
                                      "v-badge",
                                      {
                                        attrs: {
                                          left: "",
                                          color: "secondary",
                                          content: "Top",
                                          "offset-x": "10",
                                          "offset-y": "10",
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "offerta" }, [
                                          _vm._v(_vm._s(off.o)),
                                        ]),
                                      ]
                                    )
                                  : off.o == _vm.Constants.OFFERTA.PASSO
                                  ? _c("span")
                                  : _c("span", { staticClass: "offerta" }, [
                                      _vm._v(_vm._s(off.o)),
                                    ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _vm.offerteCompletate
                      ? _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("v-divider"),
                            _vm._v(" "),
                            _c("div", { staticClass: "ma-4 text-body-1" }, [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.esito_buste),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _vm.admin
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "mb-4",
                                    attrs: {
                                      depressed: "",
                                      color: "primary",
                                      rounded: "",
                                      loading: _vm.loading,
                                    },
                                    on: { click: _vm.esito },
                                  },
                                  [_vm._v("Avanti")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _c("div", { staticClass: "text-center" }, [
                  _vm.active
                    ? _c("div", [
                        !_vm.offerto && !_vm.passato
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-center align-center ma-4",
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      depressed: "",
                                      color: "primary",
                                      rounded: "",
                                      id: "numpad-btn",
                                    },
                                    on: { click: _vm.showNumpad },
                                  },
                                  [_vm._v("\n            Offerta\n          ")]
                                ),
                                _vm._v(" "),
                                _vm.roundStep && !_vm.roundStep.min_offerta
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          text: "",
                                          rounded: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setPasso(true)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            Passo\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm.ruoloCalciatoreInAstaCompletato
                          ? _c(
                              "div",
                              { staticClass: "ma-4" },
                              [
                                _c(
                                  "v-chip",
                                  { attrs: { outlined: "", color: "error" } },
                                  [_vm._v(" Ruolo completato ")]
                                ),
                              ],
                              1
                            )
                          : _vm.passato
                          ? _c("div", { staticClass: "ma-4" }, [
                              _c(
                                "div",
                                { staticClass: "error--text text-button" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "error--text",
                                      attrs: { left: "" },
                                    },
                                    [_vm._v("airline_stops")]
                                  ),
                                  _vm._v(
                                    "\n            Hai passato\n          "
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm.offerto
                          ? _c(
                              "div",
                              [
                                _c("squadra-offerta", {
                                  attrs: {
                                    offerta: _vm.miaOfferta,
                                    label: "La mia offerta",
                                    uid: _vm.user_uid,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerteCompletate
                    ? _c(
                        "div",
                        { staticClass: "ma-4" },
                        [
                          _vm.admin
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    rounded: "",
                                    large: "",
                                  },
                                  on: { click: _vm.apriBuste },
                                },
                                [_vm._v("Apri buste")]
                              )
                            : _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "text-body-2" },
                                  [
                                    _c("v-progress-circular", {
                                      attrs: {
                                        indeterminate: "",
                                        size: 15,
                                        width: 2,
                                      },
                                    }),
                                    _vm._v(
                                      "\n            In attesa che l'admin apra le buste...\n          "
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                        ],
                        1
                      )
                    : (_vm.offerto && !_vm.offerteCompletate) ||
                      (_vm.admin && !_vm.active)
                    ? _c("div", { staticClass: "pa-2" }, [
                        _c(
                          "div",
                          { staticClass: "text-body-2" },
                          [
                            _c("v-progress-circular", {
                              attrs: { indeterminate: "", size: 15, width: 2 },
                            }),
                            _vm._v(
                              "\n          In attesa degli altri partecipanti...\n        "
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.squadra(_vm.user_uid) && !_vm.offerto && _vm.active
              ? _c(
                  "div",
                  { staticClass: "pa-4" },
                  [
                    _c("squadra-info-panel", {
                      attrs: { id_squadra: _vm.user_uid },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.my_squadra
              ? _c(
                  "div",
                  { staticClass: "px-4 pb-4" },
                  [
                    _c(
                      "v-list",
                      {
                        staticClass:
                          "recycle-scroller navy darken-1 pb-2 rounded",
                        class: { "nice-scroll": !_vm.is_mobile },
                      },
                      [
                        _c("div", { staticClass: "text-center py-2" }, [
                          _vm._v("Pianificazione"),
                        ]),
                        _vm._v(" "),
                        _c("asta-consiglio"),
                        _vm._v(" "),
                        _vm._l(
                          _vm.myPlan[_vm.ruolo_abc],
                          function (slotData, slot, i) {
                            return _c("asta-slot", {
                              key: _vm.ruolo_abc + "_" + slot,
                              attrs: {
                                ruolo_abc: _vm.ruolo_abc,
                                iSlot: slot,
                                i: i,
                              },
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }